import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    closed: {
        minWidth: 100,
        backgroundColor: "#00B71D",
        color: "black",
        textAlign: "center",
        fontWeight: "bold",
        borderRadius: 5,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
    },
    open: {
        minWidth: 100,
        backgroundColor: "#FF4330",
        color: "black",
        textAlign: "center",
        fontWeight: "bold",
        borderRadius: 5,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
    }
}));

export {useStyles};